import { render, staticRenderFns } from "./FormDependentFaixaContribuicao.vue?vue&type=template&id=389cc1e7"
import script from "./FormDependentFaixaContribuicao.vue?vue&type=script&lang=js"
export * from "./FormDependentFaixaContribuicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports